import {
  ColumnElement,
  FieldElement,
  ImageElement,
  LayoutSize,
  TextElement,
} from "@entaconsulting/form";
import { get, isNumber, isObject, set } from "lodash";
import getMostGenericBreakpoint from "./getMostGenericBreakpoint";

const reduceSizeByBreakpoint = (
  element: FieldElement | ColumnElement | ImageElement | TextElement
): LayoutSize => {
  let size = element.size;

  if (isNumber(size)) {
    size--;
  }

  if (isObject(size)) {
    const mostGenericBreakpoint = getMostGenericBreakpoint(size);
    let currentSize = get(size, mostGenericBreakpoint) as number;
    const newSize = currentSize - 1;
    set(size, mostGenericBreakpoint, newSize);
  }

  return size as LayoutSize;
};

export default reduceSizeByBreakpoint;
